import { getEnvironment, getOrigin, getEnvironmentKey } from "../utils/environmentsUtil";

export default {
  methods: {
    getEnvironment,
    getOrigin,
    getEnvironmentKey
  }
}